import { render, staticRenderFns } from "./DashboardDelivery.vue?vue&type=template&id=65de3a60&"
import script from "./DashboardDelivery.vue?vue&type=script&lang=js&"
export * from "./DashboardDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports